export default __webpack_public_path__ + "static/media/hht2_ep12_book_wp_01.5dc87e2f.jpg";